export const CONFIGURATOR_REQUIRED_JOINT_TYPES = [
  "sag",
  "sol",
  "on",
  "arka",
] as const;

export type ConfiguratorRequiredJointType =
  (typeof CONFIGURATOR_REQUIRED_JOINT_TYPES)[number];

export function isConfiguratorRequiredJointType(
  type?: string,
): type is ConfiguratorRequiredJointType {
  return CONFIGURATOR_REQUIRED_JOINT_TYPES.includes(
    type as ConfiguratorRequiredJointType,
  );
}
